import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AddIcon from '@mui/icons-material/Add';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import SettingsIcon from '@mui/icons-material/Settings';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import { useParties } from '../../contexts/PartiesContext';
import { DeadTasks } from '../../pages/DeadTasks';
import { UnresponsiveParties } from '../../pages/UnresponsiveParties/UnresponsiveParties';
import { AllocationRequests } from '../../pages/registry/allocationRequest/AllocationRequests';
import { Burns } from '../../pages/registry/burn/Burns';
import { Configurations } from '../../pages/registry/configuration/Configurations';
import { Holdings } from '../../pages/registry/holdings/Holdings';
import { Mints } from '../../pages/registry/mint/Mints';
import { Onboarding } from '../../pages/registry/onboarding/Onboarding';
import { Transfers } from '../../pages/registry/transfer/Transfers';
import { ModuleRoute } from '../../routes/types';
import { UtilityBackend } from '../../utils/UtilityAutomationApiClient';
import useProviderService from '../queries/registry/onboarding/useProviderService';
import useRegistrarService from '../queries/registry/onboarding/useRegistrarService';
import { useInboundAllocationRequestCount } from './useInboundAllocationRequests';

const sidebarEntries: ModuleRoute[] = [
  {
    label: 'Onboarding',
    path: 'onboarding',
    element: <Onboarding />,
    icon: <AdminPanelSettingsIcon fontSize="small" />,
  },
];

const configurationEntry: ModuleRoute = {
  label: 'Configurations',
  path: 'configurations',
  icon: <SettingsIcon fontSize="small" />,
  element: <Configurations />,
};

const holderEntries: ModuleRoute[] = [
  {
    label: 'Holdings',
    path: 'holdings',
    element: <Holdings />,
    icon: <AccountBalanceWalletIcon fontSize="small" />,
  },
  {
    label: 'Transfers',
    path: 'transfers',
    element: <Transfers />,
    icon: <CompareArrowsIcon fontSize="small" />,
  },
  { label: 'Mints', path: 'mints', element: <Mints />, icon: <AddIcon fontSize="small" /> },
  { label: 'Burns', path: 'burns', element: <Burns />, icon: <WhatshotIcon fontSize="small" /> },
  {
    label: 'Allocation Requests',
    path: 'allocationRequest',
    element: <AllocationRequests />,
    icon: <PlaylistAddIcon />,
    getNotificationHook: useInboundAllocationRequestCount,
  },
];

const operatorEntries: ModuleRoute[] = [
  {
    label: 'Dead Tasks',
    path: 'dead-tasks',
    icon: <DeleteSweepIcon fontSize="small" />,
    element: <DeadTasks backend={UtilityBackend.REGISTRY} />,
  },
  {
    label: 'Unresponsive parties',
    path: 'unresponsive-parties',
    icon: <NoAccountsIcon fontSize="small" />,
    element: <UnresponsiveParties disableVirtualization backend={UtilityBackend.REGISTRY} />,
  },
];

export const useRegistryEntries = () => {
  const registrarService = useRegistrarService();
  const providerService = useProviderService();
  const { operator, party } = useParties();

  const isRegistrar = !!registrarService.data;
  const isProvider = !!providerService.data;
  const isOperator = operator === party;
  let entries = sidebarEntries;
  if (isOperator || isProvider || isRegistrar) {
    entries = entries.concat([configurationEntry]).concat(holderEntries);
  } else entries = entries.concat(holderEntries);

  if (isOperator) {
    entries = entries.concat(operatorEntries);
  }
  return entries;
};
